export default "__VITE_ASSET__a8e72abb__"